import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CtaFrame } from './ui/CtaFrame';
import { UrgencyBadge } from './ui/UrgencyBadge';
import { Shield, Zap, Lock, CreditCard } from 'lucide-react';
import { TropicalLeaf } from './botanical/TropicalLeaf';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
export function FinalClose() {
  return <Section className="bg-forest-mist pt-20 pb-12 relative overflow-hidden" data-id="element-243">
      <TropicalLeaf className="absolute bottom-0 -left-20 w-96 h-96 text-moss opacity-10 blur-md rotate-90" data-id="element-244" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-245">
        <h2 className="text-3xl font-serif font-bold text-forest-deep mb-6" data-id="element-246">
          🌿 HOGAR NATURAL™
        </h2>

        <div className="text-lg text-forest/80 mb-10 space-y-4 max-w-2xl mx-auto leading-relaxed" data-id="element-247">
          <p data-id="element-248">
            La próxima vez que algo duele en casa vas a saber exactamente qué
            hacer.
          </p>
          <p data-id="element-249">
            Sin improvisar. Sin correr a la farmacia. Sin buscar en Google a las
            2 AM.
          </p>
          <p className="font-medium text-forest-deep" data-id="element-250">
            Con un sistema claro, probado y listo para usar desde hoy.
          </p>
        </div>

        <CtaFrame variant="forest" className="mb-10" data-id="element-251">
          <div className="flex justify-center mb-6" data-id="element-252">
            <UrgencyBadge variant="fire" tone="light" label="ÚLTIMA OPORTUNIDAD" data-id="element-253" />
          </div>
          <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4" data-id="element-254">
            <Button variant="cta" size="lg" href={CHECKOUT_URLS.hogarNatural} className="w-full sm:w-auto min-w-[260px] flex flex-col items-center py-4" data-id="element-255">
              <span className="text-xs font-bold opacity-80 normal-case tracking-wide" data-id="element-256">
                🌿 HOGAR NATURAL $17.999 ARS
              </span>
              <span className="font-extrabold text-lg" data-id="element-257">→ EMPEZAR HOY</span>
            </Button>
            <Button variant="cta" size="lg" href={CHECKOUT_URLS.superPack} className="w-full sm:w-auto min-w-[260px] flex flex-col items-center py-4" data-id="element-258">
              <span className="text-xs font-bold opacity-90 normal-case tracking-wide" data-id="element-259">
                ⭐ SUPER PACK $27.999 ARS
              </span>
              <span className="font-extrabold text-lg" data-id="element-260">→ PACK COMPLETO</span>
            </Button>
          </div>
        </CtaFrame>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-forest/70 font-medium" data-id="element-261">
          <span className="flex items-center gap-1.5" data-id="element-262">
            <Lock className="w-4 h-4 text-moss" data-id="element-263" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-264">
            <Zap className="w-4 h-4 text-honey-dark" data-id="element-265" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-266">
            <Shield className="w-4 h-4 text-moss" data-id="element-267" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-268">
            <CreditCard className="w-4 h-4 text-forest-deep" data-id="element-269" /> Mercado Pago ·
            Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </Section>;
}